export enum PatchActionEnum {
  CREATE_MEMBERS = 'CREATE_MEMBERS',
  SUBMIT_FOR_REVIEW = 'SUBMIT_FOR_REVIEW',
  WITHDRAW_RECORDS = 'WITHDRAW_RECORDS',
  REJECT_RECORDS = 'REJECT_RECORDS',
  UPDATE_RECORDS = 'UPDATE_RECORDS',
}
